import React, { ReactNode } from 'react'
import { DecoratorNode, DOMExportOutput, LexicalNode, NodeKey, SerializedLexicalNode } from 'lexical'
import { EmbedType, MeetingResultElement } from '../../../models'
import { EmbeddedMeetingResult } from '../Embeds/EmbeddedMeetingResult'

export interface SerializedEmbeddedMeetingResultNode extends SerializedLexicalNode {
  // todo generic?
  element: MeetingResultElement
}

export class EmbeddedMeetingResultNode extends DecoratorNode<ReactNode> {
  // todo generic ?
  __element: MeetingResultElement

  static getType(): string {
    return EmbedType.MEETING_RESULT
  }

  static clone(node: EmbeddedMeetingResultNode): EmbeddedMeetingResultNode {
    return new EmbeddedMeetingResultNode(node.__element, node.__key)
  }

  constructor(element: MeetingResultElement, key?: NodeKey) {
    super(key)
    this.__element = element
  }

  createDOM(): HTMLElement {
    return document.createElement('div')
  }

  isBlock() {
    return true
  }

  updateDOM(): false {
    return false
  }

  decorate(): ReactNode {
    return <EmbeddedMeetingResult element={this.__element} />
  }

  exportJSON(): SerializedEmbeddedMeetingResultNode {
    return {
      type: EmbedType.MEETING_RESULT,
      version: 1,
      element: this.__element,
    }
  }

  static importJSON(_serializedNode: SerializedEmbeddedMeetingResultNode): EmbeddedMeetingResultNode {
    return $createEmbeddedMeetingResultNode(_serializedNode.element)
  }

  exportDOM(): DOMExportOutput {
    return {
      element: document.createTextNode(`@embed(meetingResult(${JSON.stringify({ ...this.__element.parameters, displayId: this.__element.displayId })}))`),
    }
  }
}

export const $createEmbeddedMeetingResultNode = (element: MeetingResultElement): EmbeddedMeetingResultNode => new EmbeddedMeetingResultNode(element)

export const $isEmbeddedMeetingResultNode = (node: LexicalNode | null | undefined): node is EmbeddedMeetingResultNode =>
  node instanceof EmbeddedMeetingResultNode
